import { Link, useRouter } from "@tanstack/react-router";
import { AlertCircle, ArrowLeft, Home } from "lucide-react";
import { cn } from "~/lib/utils";
import { Button } from "./ui/button";

export function NotFoundComponent() {
	const router = useRouter();

	return (
		<div className="min-h-screen bg-gradient-to-b from-black to-[#0F2231] flex items-center justify-center p-4">
			<div className="w-full max-w-md">
				<div className="text-center">
					<div className="bg-red-500/10 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6">
						<AlertCircle className="w-8 h-8 text-red-500" />
					</div>

					<h1 className="text-2xl font-bold text-white mb-2">Page Not Found</h1>

					<p className="text-white/60 mb-8">
						The page you're looking for doesn't exist or has been moved.
					</p>

					<div className="space-y-3">
						{/* Back button */}
						<Button
							size="lg"
							className={cn(
								"w-full text-base font-medium rounded-2xl",
								"border-white/10 bg-white/5 text-white/70 backdrop-blur-sm",
								"hover:bg-white/[0.07] hover:border-white/20 hover:text-white transition-all duration-200",
								"active:scale-[0.98]",
							)}
							onClick={() => router.history.back()}
						>
							<ArrowLeft className="w-4 h-4 mr-2" />
							Go Back
						</Button>

						{/* Home button */}
						<Button
							size="lg"
							className={cn(
								"w-full text-base font-medium rounded-2xl",
								"border-white/10 bg-white/5 text-white/70 backdrop-blur-sm",
								"hover:bg-white/[0.07] hover:border-white/20 hover:text-white transition-all duration-200",
								"active:scale-[0.98]",
							)}
							asChild
						>
							<Link to="/">
								<>
									<Home className="w-4 h-4 mr-2" />
									Back to Home
								</>
							</Link>
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
